// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perm-page {
    padding: 24px;
    font-family: var(--font-sans, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif);
}

/* Title row — matches the plain title/DC-dropdown header used on Routing, Dashboard, DC File Upload */
.settings-title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 2px;
    margin-bottom: 8px;
}

.settings-title {
    font-family: var(--font-sans, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif);
    font-size: 25px;
    font-weight: bold;
    color: #1d2939;
    margin: 0;
    padding: 10px;
}

.settings-title-actions {
    display: flex;
    align-items: center;
    gap: 12px;
}

.customSelect {
    width: 160px;
    padding: 8px;
    font-size: 12px;
    border: 1px solid #0A74DA;
    font-weight: bold;
    background-color: white;
    border-radius: 5px;
    cursor: pointer;
}

.customSelect.disabled {
    color: grey;
    cursor: not-allowed;
}

.customSelect.enabled {
    color: #0A74DA;
}

/* Card container */
.perm-card {
    background: #ffffff;
    border: 1px solid #eceef2;
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 8px 24px rgba(16, 24, 40, 0.06);
    overflow: hidden;
}

.perm-count {
    font-size: 12px;
    font-weight: 600;
    color: #1976d2;
    background: #e3f2fd;
    border: 1px solid #bbdefb;
    padding: 5px 13px;
    border-radius: 20px;
    white-space: nowrap;
}

/* Table */
.perm-table-scroll {
    overflow-x: auto;
}

.perm-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 13px;
    min-width: 860px;
}

.perm-table th {
    color: #475467;
    font-weight: 600;
    padding: 10px 12px;
    text-align: center;
    background: #f8fafc;
    white-space: nowrap;
}

.perm-group-row .screen-head {
    font-size: 12.5px;
    color: #344054;
    border-bottom: 1px solid #eef0f3;
    border-left: 1px solid #eef0f3;
}

.perm-sub-row th {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #98a2b3;
    padding: 7px 12px;
    border-bottom: 1px solid #e9ecf1;
}

.perm-table th.user-col {
    text-align: left;
    width: 160px;
    border-bottom: 1px solid #e9ecf1;
}

.perm-table th.access-col {
    border-bottom: 1px solid #e9ecf1;
    border-left: 1px solid #eef0f3;
}

.perm-table th.action-col {
    border-bottom: 1px solid #e9ecf1;
    border-left: 1px solid #eef0f3;
    width: 96px;
}

.perm-table td {
    padding: 12px;
    text-align: center;
    color: #101828;
    vertical-align: middle;
    border-bottom: 1px solid #f2f4f7;
}

.perm-table tbody tr {
    transition: background-color 0.15s ease;
}

.perm-table tbody tr:hover {
    background: #f9fbff;
}

.perm-table tbody tr:last-child td {
    border-bottom: none;
}

/* Subtle separator between screen groups */
.perm-table td.group-end {
    border-right: 1px solid #f2f4f7;
}

.perm-table td.user-cell {
    text-align: left;
    font-weight: 600;
    color: #1d2939;
    display: flex;
    align-items: center;
}

/* Allowed / denied marks */
.mark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
}

.mark-yes {
    color: #0f6e56;
    background: #e6f6f0;
}

.mark-no {
    color: #b42318;
    background: #fdeceb;
}

/* Clickable marks while a row is being edited */
.mark-editable {
    border: none;
    cursor: pointer;
    padding: 0;
    transition: transform 0.12s ease, box-shadow 0.12s ease;
}

.mark-editable:hover {
    transform: scale(1.12);
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.16);
}

/* Highlight the row currently in edit mode */
.perm-table tbody tr.row-editing {
    background: #f3f9ff;
    box-shadow: inset 3px 0 0 #1976d2;
}

.perm-table tbody tr.row-editing:hover {
    background: #f3f9ff;
}

/* Row action buttons (Edit / Save / Cancel) */
.row-action-group {
    display: inline-flex;
    gap: 6px;
    justify-content: center;
}

.row-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    border: 1px solid transparent;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.row-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.row-btn-edit {
    color: #1976d2;
    background: #e3f2fd;
    border-color: #bbdefb;
}

.row-btn-edit:not(:disabled):hover {
    background: #bbdefb;
}

.row-btn-save {
    color: #ffffff;
    background: #0f6e56;
    border-color: #0f6e56;
}

.row-btn-save:hover {
    background: #0c5d49;
}

.row-btn-cancel {
    color: #667085;
    background: #f2f4f7;
    border-color: #e4e7ec;
}

.row-btn-cancel:hover {
    background: #e4e7ec;
    color: #344054;
}

/* Access pills */
.pill {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    padding: 4px 12px;
    border-radius: 20px;
    font-weight: 600;
    letter-spacing: 0.01em;
}

.pill-full {
    background: #e1f5ee;
    color: #085041;
    box-shadow: inset 0 0 0 1px rgba(8, 80, 65, 0.12);
}

.pill-partial {
    background: #fdf3e3;
    color: #93600b;
    box-shadow: inset 0 0 0 1px rgba(147, 96, 11, 0.14);
}

/* Avatars */
.avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
    margin-right: 12px;
    flex-shrink: 0;
    box-shadow: 0 0 0 2px #ffffff, 0 1px 2px rgba(16, 24, 40, 0.12);
}

.av-j { background: #b5d4f4; color: #0c447c; }
.av-s { background: #cecbf6; color: #3c3489; }
.av-a { background: #9fe1cb; color: #085041; }
.av-d { background: #f5c4b3; color: #712b13; }

/* Legend */
.perm-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 22px;
    padding: 16px 24px;
    border-top: 1px solid #f0f2f5;
    background: #fcfcfd;
    font-size: 12.5px;
    color: #667085;
    align-items: center;
}

.perm-legend .legend-item {
    display: flex;
    align-items: center;
    gap: 7px;
}

.perm-legend .mark {
    width: 18px;
    height: 18px;
}

.group-name-cell {
    font-weight: 600;
    color: #1d2939;
}

/* Capability button in action column */
.row-btn-capability {
    color: #6941c6;
    background: #f4f3ff;
    border-color: #d9d6fe;
}

.row-btn-capability:hover:not(:disabled) {
    background: #ede9fe;
}

/* Capability table overrides */
.perm-table-caps th.cap-col {
    min-width: 110px;
    text-align: center;
    vertical-align: middle;
    padding: 10px 8px;
}

.cap-col-id {
    display: block;
    font-size: 10px;
    color: #98a2b3;
    font-weight: 600;
    letter-spacing: 0.04em;
    margin-bottom: 2px;
}

.cap-col-nm {
    display: block;
    font-size: 11.5px;
    font-weight: 600;
    color: #344054;
    white-space: nowrap;
}

.cap-group-col {
    min-width: 180px;
    text-align: left;
    padding: 11px 16px;
    font-weight: 600;
    font-size: 11.5px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #475467;
    background: #f8fafc;
    border-bottom: 1px solid #e9ecf1;
}

.cap-group-cell {
    padding: 13px 16px;
    vertical-align: middle;
}

.cap-mark-cell {
    text-align: center;
    vertical-align: middle;
    padding: 10px 6px;
}

.cap-action-cell {
    text-align: center;
    vertical-align: middle;
    padding: 10px 16px;
}

.cap-loading-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #d0d5dd;
    animation: pulse 1.2s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% { opacity: 0.4; }
    50% { opacity: 1; }
}

.perm-empty-cell {
    text-align: center;
    padding: 32px !important;
    color: #98a2b3;
    font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/components/settings/Permission.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,wFAAwF;AAC5F;;AAEA,sGAAsG;AACtG;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,wFAAwF;IACxF,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,+EAA+E;IAC/E,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA,UAAU;AACV;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,2CAA2C;AAC3C;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA,gDAAgD;AAChD;IACI,YAAY;IACZ,eAAe;IACf,UAAU;IACV,uDAAuD;AAC3D;;AAEA;IACI,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA,6CAA6C;AAC7C;IACI,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,8CAA8C;AAC9C;IACI,oBAAoB;IACpB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,4EAA4E;AAChF;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,iBAAiB;AACjB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mDAAmD;AACvD;;AAEA,YAAY;AACZ;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,+DAA+D;AACnE;;AAEA,QAAQ,mBAAmB,EAAE,cAAc,EAAE;AAC7C,QAAQ,mBAAmB,EAAE,cAAc,EAAE;AAC7C,QAAQ,mBAAmB,EAAE,cAAc,EAAE;AAC7C,QAAQ,mBAAmB,EAAE,cAAc,EAAE;;AAE7C,WAAW;AACX;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA,uCAAuC;AACvC;IACI,cAAc;IACd,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,WAAW,YAAY,EAAE;IACzB,MAAM,UAAU,EAAE;AACtB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;IACd,kBAAkB;AACtB","sourcesContent":[".perm-page {\n    padding: 24px;\n    font-family: var(--font-sans, \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", Arial, sans-serif);\n}\n\n/* Title row — matches the plain title/DC-dropdown header used on Routing, Dashboard, DC File Upload */\n.settings-title-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 10px 2px;\n    margin-bottom: 8px;\n}\n\n.settings-title {\n    font-family: var(--font-sans, \"Segoe UI\", \"Roboto\", \"Helvetica Neue\", Arial, sans-serif);\n    font-size: 25px;\n    font-weight: bold;\n    color: #1d2939;\n    margin: 0;\n    padding: 10px;\n}\n\n.settings-title-actions {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.customSelect {\n    width: 160px;\n    padding: 8px;\n    font-size: 12px;\n    border: 1px solid #0A74DA;\n    font-weight: bold;\n    background-color: white;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.customSelect.disabled {\n    color: grey;\n    cursor: not-allowed;\n}\n\n.customSelect.enabled {\n    color: #0A74DA;\n}\n\n/* Card container */\n.perm-card {\n    background: #ffffff;\n    border: 1px solid #eceef2;\n    border-radius: 14px;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.04), 0 8px 24px rgba(16, 24, 40, 0.06);\n    overflow: hidden;\n}\n\n.perm-count {\n    font-size: 12px;\n    font-weight: 600;\n    color: #1976d2;\n    background: #e3f2fd;\n    border: 1px solid #bbdefb;\n    padding: 5px 13px;\n    border-radius: 20px;\n    white-space: nowrap;\n}\n\n/* Table */\n.perm-table-scroll {\n    overflow-x: auto;\n}\n\n.perm-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    font-size: 13px;\n    min-width: 860px;\n}\n\n.perm-table th {\n    color: #475467;\n    font-weight: 600;\n    padding: 10px 12px;\n    text-align: center;\n    background: #f8fafc;\n    white-space: nowrap;\n}\n\n.perm-group-row .screen-head {\n    font-size: 12.5px;\n    color: #344054;\n    border-bottom: 1px solid #eef0f3;\n    border-left: 1px solid #eef0f3;\n}\n\n.perm-sub-row th {\n    font-size: 11px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #98a2b3;\n    padding: 7px 12px;\n    border-bottom: 1px solid #e9ecf1;\n}\n\n.perm-table th.user-col {\n    text-align: left;\n    width: 160px;\n    border-bottom: 1px solid #e9ecf1;\n}\n\n.perm-table th.access-col {\n    border-bottom: 1px solid #e9ecf1;\n    border-left: 1px solid #eef0f3;\n}\n\n.perm-table th.action-col {\n    border-bottom: 1px solid #e9ecf1;\n    border-left: 1px solid #eef0f3;\n    width: 96px;\n}\n\n.perm-table td {\n    padding: 12px;\n    text-align: center;\n    color: #101828;\n    vertical-align: middle;\n    border-bottom: 1px solid #f2f4f7;\n}\n\n.perm-table tbody tr {\n    transition: background-color 0.15s ease;\n}\n\n.perm-table tbody tr:hover {\n    background: #f9fbff;\n}\n\n.perm-table tbody tr:last-child td {\n    border-bottom: none;\n}\n\n/* Subtle separator between screen groups */\n.perm-table td.group-end {\n    border-right: 1px solid #f2f4f7;\n}\n\n.perm-table td.user-cell {\n    text-align: left;\n    font-weight: 600;\n    color: #1d2939;\n    display: flex;\n    align-items: center;\n}\n\n/* Allowed / denied marks */\n.mark {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n}\n\n.mark-yes {\n    color: #0f6e56;\n    background: #e6f6f0;\n}\n\n.mark-no {\n    color: #b42318;\n    background: #fdeceb;\n}\n\n/* Clickable marks while a row is being edited */\n.mark-editable {\n    border: none;\n    cursor: pointer;\n    padding: 0;\n    transition: transform 0.12s ease, box-shadow 0.12s ease;\n}\n\n.mark-editable:hover {\n    transform: scale(1.12);\n    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.16);\n}\n\n/* Highlight the row currently in edit mode */\n.perm-table tbody tr.row-editing {\n    background: #f3f9ff;\n    box-shadow: inset 3px 0 0 #1976d2;\n}\n\n.perm-table tbody tr.row-editing:hover {\n    background: #f3f9ff;\n}\n\n/* Row action buttons (Edit / Save / Cancel) */\n.row-action-group {\n    display: inline-flex;\n    gap: 6px;\n    justify-content: center;\n}\n\n.row-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 30px;\n    height: 30px;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    cursor: pointer;\n    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n}\n\n.row-btn:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n\n.row-btn-edit {\n    color: #1976d2;\n    background: #e3f2fd;\n    border-color: #bbdefb;\n}\n\n.row-btn-edit:not(:disabled):hover {\n    background: #bbdefb;\n}\n\n.row-btn-save {\n    color: #ffffff;\n    background: #0f6e56;\n    border-color: #0f6e56;\n}\n\n.row-btn-save:hover {\n    background: #0c5d49;\n}\n\n.row-btn-cancel {\n    color: #667085;\n    background: #f2f4f7;\n    border-color: #e4e7ec;\n}\n\n.row-btn-cancel:hover {\n    background: #e4e7ec;\n    color: #344054;\n}\n\n/* Access pills */\n.pill {\n    display: inline-flex;\n    align-items: center;\n    font-size: 11px;\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-weight: 600;\n    letter-spacing: 0.01em;\n}\n\n.pill-full {\n    background: #e1f5ee;\n    color: #085041;\n    box-shadow: inset 0 0 0 1px rgba(8, 80, 65, 0.12);\n}\n\n.pill-partial {\n    background: #fdf3e3;\n    color: #93600b;\n    box-shadow: inset 0 0 0 1px rgba(147, 96, 11, 0.14);\n}\n\n/* Avatars */\n.avatar {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    font-size: 12px;\n    font-weight: 600;\n    margin-right: 12px;\n    flex-shrink: 0;\n    box-shadow: 0 0 0 2px #ffffff, 0 1px 2px rgba(16, 24, 40, 0.12);\n}\n\n.av-j { background: #b5d4f4; color: #0c447c; }\n.av-s { background: #cecbf6; color: #3c3489; }\n.av-a { background: #9fe1cb; color: #085041; }\n.av-d { background: #f5c4b3; color: #712b13; }\n\n/* Legend */\n.perm-legend {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 22px;\n    padding: 16px 24px;\n    border-top: 1px solid #f0f2f5;\n    background: #fcfcfd;\n    font-size: 12.5px;\n    color: #667085;\n    align-items: center;\n}\n\n.perm-legend .legend-item {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n}\n\n.perm-legend .mark {\n    width: 18px;\n    height: 18px;\n}\n\n.group-name-cell {\n    font-weight: 600;\n    color: #1d2939;\n}\n\n/* Capability button in action column */\n.row-btn-capability {\n    color: #6941c6;\n    background: #f4f3ff;\n    border-color: #d9d6fe;\n}\n\n.row-btn-capability:hover:not(:disabled) {\n    background: #ede9fe;\n}\n\n/* Capability table overrides */\n.perm-table-caps th.cap-col {\n    min-width: 110px;\n    text-align: center;\n    vertical-align: middle;\n    padding: 10px 8px;\n}\n\n.cap-col-id {\n    display: block;\n    font-size: 10px;\n    color: #98a2b3;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    margin-bottom: 2px;\n}\n\n.cap-col-nm {\n    display: block;\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #344054;\n    white-space: nowrap;\n}\n\n.cap-group-col {\n    min-width: 180px;\n    text-align: left;\n    padding: 11px 16px;\n    font-weight: 600;\n    font-size: 11.5px;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n    color: #475467;\n    background: #f8fafc;\n    border-bottom: 1px solid #e9ecf1;\n}\n\n.cap-group-cell {\n    padding: 13px 16px;\n    vertical-align: middle;\n}\n\n.cap-mark-cell {\n    text-align: center;\n    vertical-align: middle;\n    padding: 10px 6px;\n}\n\n.cap-action-cell {\n    text-align: center;\n    vertical-align: middle;\n    padding: 10px 16px;\n}\n\n.cap-loading-dot {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #d0d5dd;\n    animation: pulse 1.2s ease-in-out infinite;\n}\n\n@keyframes pulse {\n    0%, 100% { opacity: 0.4; }\n    50% { opacity: 1; }\n}\n\n.perm-empty-cell {\n    text-align: center;\n    padding: 32px !important;\n    color: #98a2b3;\n    font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
